<template>
  <div class="flagImg">
    <img :src="`${data.flagFile}`" :alt="`${data.country}國旗`" />
  </div>
</template>

<script>
export default {
  name: "FlagFile",
  props: {
    data: {
      type: Object,
      default() {
        return {
          flagFile: "",
        };
      },
    },
  },
  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.flagImg {
  width: 100px;
  border: 1px solid #cfcfcf;
  
  img {
    width: 100%;
  }
}
</style>
